var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-step", {
    attrs: {
      stepperGrpCd: "SAFETY_ACTION_STEP_CD",
      currentStepCd: _vm.currentStepCd,
      param: _vm.param,
    },
    on: {
      closePopup: _vm.closePopup,
      currentStep: _vm.currentStep,
      stepClick: _vm.stepClick,
    },
    model: {
      value: _vm.stepCd,
      callback: function ($$v) {
        _vm.stepCd = $$v
      },
      expression: "stepCd",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }